// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test'
      //suggestionPosition: 'left',
      suggestionWidth: 300,
  }
};

(function () {
  BoostPFS.inject(this);

  function isSaltRoomProduct(data) {
    return data && (String(data.id) === '15904431276415' || data.handle === 'bespoke-himalayan-salt-rooms');
  }

  function addSaltRoomSuggestion(data) {
    var service = boostPFSConfig.general.salt_room_service;
    if (!Array.isArray(data) || !service || String(service.id) !== '15904431276415' || service.available !== false) return data;
    var query = Utils.getValueInObjectArray('prev_query', data) || Utils.getValueInObjectArray('query', data) || Globals.currentTerm;
    var term = String(query || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
    if (!/^(?:bespoke )?(?:himalayan )?salt rooms?$/.test(term)) return data;
    var products = Utils.getValueInObjectArray('products', data) || [];
    if (!Array.isArray(products) || products.some(isSaltRoomProduct)) return data;
    var result = data.map(function(entry) { return {key: entry.key, values: entry.values}; });
    function setValue(key, value) {
      var entry = result.find(function(item) { return item.key === key; });
      if (entry) entry.values = value;
      else result.push({key: key, values: value});
    }
    setValue('products', [service].concat(products));
    setValue('all_empty', false);
    setValue('total_product', (Number(Utils.getValueInObjectArray('total_product', data)) || products.length) + 1);
    return result;
  }

  var originalRenderMenu = SearchInput.prototype._bindAutoCompleteRenderMenu;
  SearchInput.prototype._bindAutoCompleteRenderMenu = function(element, data) {
    return originalRenderMenu.call(this, element, addSaltRoomSuggestion(data));
  };

  var originalProductSetData = InstantSearchResultItemProduct.prototype.setData;
  InstantSearchResultItemProduct.prototype.setData = function(data) {
    var result = originalProductSetData.apply(this, arguments);
    if (isSaltRoomProduct(this.data)) {
      this.url = this.url.split('?')[0].split('#')[0] + '#salt-room-enquiry';
    }
    return result;
  };

  var originalProductPrice = InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice;
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    if (isSaltRoomProduct(this.data)) {
      return '<p class="{{class.searchSuggestion}}-product-price">' +
        Utils.escape(boostPFSConfig.general.salt_room_quoted) + '</p>' +
        '<p class="salt-room-card__enquiry">' +
        Utils.escape(boostPFSConfig.general.salt_room_enquiry) + '</p>';
    }
    return originalProductPrice.apply(this, arguments);
  };


  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if(!suggestionElement) suggestionElement = this.suggestionElement;
    if(!searchElement) searchElement = this.searchElement;
    if(!searchBoxId) searchBoxId = this.searchBoxId;
  };

  InstantSearch.prototype.beforeBindEvents = function(id) {
    if(!id) id = this.id;
      jQ(document).ready(function() {
          jQ(document).off('submit', '.search-form, #search-form');
      });
  };

})();
